import React, { useEffect, useState } from "react";
import TextInput from "../../../components/forms/TextInput";
import RadioInput from "../../../components/forms/RadioInput";
import TextArea from "../../../components/forms/TextArea";
import LabelInput from "../../../components/forms/Label";
import InfoPopup from "../../../components/create-certification/InfoPopup";
import { preTransactionInfoOtherService } from "../../../utils/constant";
import Error from "../../../components/Alert/Error";
import { fieldRequiredMessage } from "../../../errors/errors";
import TimePeriodInput from "../../../components/forms/TimePeriodInput";
import { formatDate } from "../../../utils/utils";
import DefaultRadioInput from "../../../components/forms/DefaultRadioInput";

function OtherServiceAdmin({
  formData,
  setFormData,
  errors,
  errorCount,
  register,
  setValue,
  reset,
  unregister,
}) {
  // useEffect(() => {
  //   reset();
  // }, [reset]);
  const [preTransactionRequired, setPreTransactionRequired] = useState(true);
  const [preTransactionChecked, setPreTransactionChecked] = useState();
  const [
    estimatedFirstTransDateRequired,
    setEstimatestimatedFirstTransDateRequired,
  ] = useState(true);
  const [contractPeriodRequired, setContractPeriodRequired] = useState(true);

  useEffect(() => {
    if (
      formData?.preTransactionCertification === true ||
      formData?.preTransactionCertification === false
    ) {
      setPreTransactionRequired(false);
      setPreTransactionChecked(formData?.preTransactionCertification);
    }
  }, [formData?.preTransactionCertification]);

  useEffect(() => {
    setValue("contractTimePeriod", formData?.contractTimePeriod || "");
    setValue(
      "estimatedFirstTransDate",
      formData?.estimatedFirstTransDate || ""
    );
    setValue(
      "preTransactionCertification",
      formData?.preTransactionCertification || ""
    );
    setValue(
      "postTransactionCertification",
      formData?.postTransactionCertification || ""
    );
    setValue("transactionDescription", formData?.transactionDescription || "");
  }, [formData, setValue, preTransactionChecked]);

  const handleChangeInput = (fieldName, value, fieldsToUnregister) => {
    setFormData({ ...formData, [fieldName]: value });
    setValue(fieldName, value);

    // Mettre à jour les champs à désenregistrer
    if (fieldsToUnregister) {
      // Désenregistrer les champs
      for (const field of fieldsToUnregister) {
        unregister(field);
      }
    }
    if (
      fieldName === "preTransactionCertification" ||
      fieldName === "postTransactionCertification"
    ) {
      console.log(`value: ${typeof value}`);
      setPreTransactionChecked(value);
      setPreTransactionRequired(false);
    }
    if (fieldName === "estimatedFirstTransDate") {
      setContractPeriodRequired(false);
    }

    if (fieldName === "contractTimePeriod") {
      setEstimatestimatedFirstTransDateRequired(false);
    }
  };

  return (
    <div className="w-full">
      <span className="text-coc-blue">
        Carbon offset Service certification can apply to any kind of service
        (e.g. logistics, events etc.)
      </span>
      <div className="col max-w-[390px] mt-4 pl-0">
        <TextArea
          onChange={(e) =>
            handleChangeInput("transactionDescription", e.target.value)
          }
          register={{
            ...register("transactionDescription", { required: true }),
          }}
          name="transactionDescription"
          defaultValue={formData?.transactionDescription}
          label="Service description"
          placeholder="Service description, additional information:"
        />
        {errors.transactionDescription &&
          errors.transactionDescription.type === "required" && (
            <Error
              key={errorCount}
              text={fieldRequiredMessage("Service Description")}
            />
          )}
      </div>
      <div className="flex mt-10">
        <div className="col">
          <TextInput
            type="date"
            label="Date of service"
            defaultValue={
              formData?.estimatedFirstTransDate &&
              formatDate(formData?.estimatedFirstTransDate)
            }
            placeholder="dd/mm/yy"
            onChange={(e) =>
              handleChangeInput("estimatedFirstTransDate", e.target.value)
            }
            register={{
              ...register("estimatedFirstTransDate", {
                required: estimatedFirstTransDateRequired,
              }),
            }}
          />
          {errors.estimatedFirstTransDate &&
            errors.estimatedFirstTransDate.type === "required" && (
              <Error
                key={errorCount}
                text={fieldRequiredMessage("Estimated Transation Date")}
              />
            )}
        </div>
        <div className="col pr-0">
          <TimePeriodInput
            setTimePeriodValue={handleChangeInput}
            register={{
              ...register("contractTimePeriod", {
                required: contractPeriodRequired,
              }),
            }}
            defaultValue={formData?.contractTimePeriod}
            fieldName="contractTimePeriod"
            label="Or"
          />
          {errors.contractTimePeriod &&
            errors.contractTimePeriod.type === "required" && (
              <Error
                key={errorCount}
                text={fieldRequiredMessage("Date Period")}
              />
            )}
        </div>
      </div>

      <div className="flex flex-col mt-6">
        <div className="flex mb-3">
          <LabelInput label="Certification" />
        </div>
        <div className="flex mb-3">
          <DefaultRadioInput
            onChange={(e) =>
              handleChangeInput("preTransactionCertification", true)
            }
            register={{
              ...register("preTransactionCertification", {
                required: preTransactionRequired,
              }),
            }}
            defaultChecked={preTransactionChecked === true}
            value={true}
            name="preTransactionCertification"
            label="Pre-Transaction(s) Certification"
            id="pre"
            htmlFor="pre"
          />
          <InfoPopup text={preTransactionInfoOtherService} />
        </div>

        <div className="flex mb-3">
          <DefaultRadioInput
            onChange={(e) =>
              handleChangeInput("preTransactionCertification", false, [])
            }
            register={{
              ...register("postTransactionCertification", {
                required: preTransactionRequired,
              }),
            }}
            defaultChecked={preTransactionChecked === false}
            value={false}
            name="postTransactionCertification"
            label="Post-Transaction(s) Certification"
            id="post"
            htmlFor="post"
          />
        </div>
      </div>
      {errors.preTransactionCertification &&
        errors.preTransactionCertification.type === "required" &&
        errors.postTransactionCertification &&
        errors.postTransactionCertification.type === "required" && (
          <Error
            key={errorCount}
            text={fieldRequiredMessage("Transaction Certification")}
          />
        )}
    </div>
  );
}

export default OtherServiceAdmin;
